import Papa from 'papaparse';

export const REQUIRED_CSV_FIELDS = ['id', 'title', 'image_link'];

export const OPTIONAL_CSV_FIELDS = [
  'price',
  'brand',
  'availability',
  'description',
  'link',
  'sale_price',
  'category',
];

export function generateCSVTemplate(): string {
  const headers = [...REQUIRED_CSV_FIELDS, ...OPTIONAL_CSV_FIELDS];
  const sampleRow: Record<string, string> = {
    id: 'SKU-001',
    title: 'Sample Product Name',
    image_link: 'https://example.com/image.jpg',
    price: '29.99 USD',
    brand: 'Brand Name',
    availability: 'in stock',
    description: 'Product description here',
    link: 'https://example.com/product',
    sale_price: '24.99 USD',
    category: 'Clothing > Dresses',
  };

  return Papa.unparse({
    fields: headers,
    data: [headers.map((h) => sampleRow[h] || '')],
  });
}

export function downloadCSVTemplate(): void {
  const csv = generateCSVTemplate();
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'product-import-template.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
